import { Button, Card, IconButton } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Delete, PostAdd } from "@material-ui/icons";
import { Dialog, DialogActions, DialogTitle, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useState } from "react";
import Avatar from "react-avatar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import MTextField from "../../components/MTextField";
import MUserAutocomplete from "../../components/MUserAutocomplete";
import NodataComponent from "../../components/NodataComponent";
import { SnackbarType } from "../../constants/appConstants";
import { getCopy } from "../../helpers/utils.helper";
import { setSnackbar } from "../../reducers/snackbarReducer";
import "./helplineContacts.scss";

export default function HelplineContacts(props) {
  const dispatch = useDispatch();
  const [helplineContacts, setHelplineContacts] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [userInput, setUserInput] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [helplineContact, setHelplineContact] = React.useState({
    users: [],
  });
  const navigate = useNavigate();
  const formFields = [];

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  React.useEffect(() => {
    getAllHelplineContacts();
  }, []);

  const getAllHelplineContacts = () => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_HELPLINE_CONTACTS)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setHelplineContacts(response.data.data);
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching helpline contacts"));
      });
  };

  const getSearchedUsers = (search) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_SEARCH_USERS, null, { search })
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          const optionWithName = response.data.data.map((user) => {
            return {
              ...user,
              name: `${user.firstName} ${user.lastName}`,
            };
          });
          setOptions(optionWithName);

          console.log(optionWithName);
        } else {
          dispatch(errorSnackbar("Error fetching users list"));
        }
      })
      .catch((err) => {
        dispatch(errorSnackbar("Error fetching users list (catch error)"));
      });
  };

  const changeHelplineContactStatus = (_id, status) => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.UPDATE_HELPLINE_CONTACTS, {
      _id,
      status,
    })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          getAllHelplineContacts();
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
      });
  };

  const getHelplineContactsView = () => {
    return helplineContacts.map((j) => (
      <TableRow>
        <TableCell>
          <span className={"font-medium"}>{j.title}</span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>
            {j.users
              .map((user) => `${user.firstName} ${user.lastName}`)
              .join(", ")}
          </span>
        </TableCell>
        <TableCell align="center">
          <Tooltip title={j.recStatus === "A" ? "Delete" : "Add"}>
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                changeHelplineContactStatus(
                  j._id,
                  j.recStatus === "A" ? "D" : "A"
                );
              }}
            >
              {j.recStatus === "A" ? (
                <Delete color={"error"} />
              ) : (
                <PostAdd color={"primary"} />
              )}
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    event.preventDefault();
    let updatedNotification = getCopy(helplineContact);
    updatedNotification[event.target.name] = event.target.value;
    setHelplineContact(updatedNotification);
  };

  const handleUserChange = (value) => {
    console.log(value);
    if (value) {
      const updatedHelplineContact = getCopy(helplineContact);
      if (updatedHelplineContact.users) {
        updatedHelplineContact.users.push(value);
      } else {
        updatedHelplineContact.users = [value];
      }
      setHelplineContact(updatedHelplineContact);
      setOptions([]);
      setUserInput("");
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setUserInput(newInputValue);
    if (newInputValue.length === 4) {
      getSearchedUsers(newInputValue);
    }
    if (newInputValue.length === 3) {
      setOptions([]);
    }
  };

  const getHelplineContactFormFields = () => {
    return (
      <>
        <div
          className={"col-12 d-flex justify-content-center align-items-center"}
        >
          <MTextField
            name={"title"}
            className="col-12"
            type={"text"}
            required={true}
            label={"Title"}
            value={helplineContact["title"]}
            onChange={handleChange}
            placeholder={"Enter title"}
            // error={getFieldError(field.key)}
            // helperText={getFieldErrorText(field.key)}
          />
        </div>
        <MUserAutocomplete
          label={"Users"}
          required={true}
          options={options}
          inputValue={userInput}
          value={null}
          onChange={(event, newValue) => {
            handleUserChange(newValue);
          }}
          onInputChange={(event, newI) => handleInputChange(event, newI)}
        />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {helplineContact.users.map((user, index) => {
            return (
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  border: "1px solid lightgray",
                  borderRadius: 4,
                  paddingTop: 8,
                  paddingBottom: 8,
                  paddingLeft: 16,
                  paddingRight: 16,
                }}
              >
                <Avatar name={`${user.name}`} round={true} size={44} />
                <div>
                  <div className={"appFontMedium"}>{user.name}</div>
                  <div className={"appFont"}>{user.userCode}</div>
                </div>
                <div>
                  <IconButton
                    onClick={() => {
                      const updatedPoc = [...helplineContact.users];
                      updatedPoc.splice(index, 1);
                      setHelplineContact({
                        ...helplineContact,
                        users: updatedPoc,
                      });
                    }}
                  >
                    <Delete color={"error"} />
                  </IconButton>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const addHelplineContacts = () => {
    handleClose();
    dispatch(startLoading);
    const params = getCopy(helplineContact);
    params.users = helplineContact.users.map((user) => user._id);
    AjaxHelper.postApi(navigate, Endpoint.ADD_HELPLINE_CONTACTS, params)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          dispatch(successSnackbar("Helpline contacts added"));
          getAllHelplineContacts();
        } else {
          dispatch(errorSnackbar("Error while adding the helpline contacts."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while adding the helpline contacts."));
      });
  };

  return (
    <div className={"helpline-contacts-component d-flex flex-column p-md-3"}>
      <div className="d-flex flex-row-reverse align-items-center justify-content-between p-md-0 p-3">
        <Button
          variant="contained"
          className="button"
          color="primary"
          onClick={() => {
            setHelplineContact({ users: [] });
            handleClickOpen();
          }}
        >
          Add
        </Button>
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>Title</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Point of contacts</span>
                </TableCell>
                <TableCell align="center">
                  <span className={"font-bold font-18"}>Action</span>
                </TableCell>
              </TableRow>
            </TableHead>
            {getHelplineContactsView()}
          </Table>
        </TableContainer>
        {helplineContacts.length > 0 ? null : <NodataComponent />}
      </Card>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>Helpline contacts form</span>
        </DialogTitle>
        <Divider />

        <div className={"jamaat-form"}>{getHelplineContactFormFields()}</div>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => addHelplineContacts()}>{"Add"}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
